import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=50b28a7c&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"
import style0 from "./Auth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports